import { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/motion";
import { Magnetic } from "@/components/fx/Magnetic";
import { Link } from "react-router-dom";

export const NAV = [
  { id: "metodo", label: "Come lavoriamo" },
  { id: "ruoli", label: "Ruoli" },
  { id: "risultati", label: "Risultati" },
  { id: "come-si-paga", label: "Come si paga" },
  { id: "domande", label: "Domande" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 24);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,box-shadow] duration-300 ${
        scrolled || open ? "border-b border-[#E7E5DF] bg-[#F7F6F2]/85 backdrop-blur-xl" : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="rl-container flex h-[72px] items-center justify-between gap-4">
        <a href="#top" onClick={go("top")} aria-label="Recruiting Lab, torna all'inizio" data-testid="header-logo-link">
          <Logo />
        </a>
        <nav className="hidden items-center gap-1 lg:flex" aria-label="Navigazione principale">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              onClick={go(n.id)}
              data-testid={`nav-link-${n.id}`}
              className="group relative rounded-full px-4 py-2 text-[14px] font-medium text-[#2C2C2A] transition-colors hover:text-[#0F6E56]"
            >
              {n.label}
              <span className="absolute inset-x-4 bottom-1 h-px origin-left scale-x-0 bg-[#0F6E56] transition-transform duration-300 group-hover:scale-x-100" />
            </a>
          ))}
          <Link to="/guide" className="rounded-full px-4 py-2 text-[14px] font-medium text-[#2C2C2A] transition-colors hover:text-[#0F6E56]" data-testid="nav-link-guide">Guide</Link>
        </nav>
        <div className="flex items-center gap-2">
          <Magnetic strength={0.25} className="hidden sm:inline-block">
            <a href="#richiedi" onClick={go("richiedi")} className="rl-btn rl-btn-amber rl-nowrap !h-11 !px-5 !text-[14px]" data-testid="header-cta-button">
              Richiedi una figura <ArrowRight size={16} className="rl-arrow" />
            </a>
          </Magnetic>
          <button
            type="button"
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#E7E5DF] bg-white lg:hidden"
            aria-expanded={open}
            aria-controls="mobile-nav"
            aria-label={open ? "Chiudi menu" : "Apri menu"}
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <nav id="mobile-nav" className="rl-container pb-6 lg:hidden" aria-label="Menu mobile" data-testid="mobile-nav">
          <ul className="flex flex-col border-t border-[#E7E5DF] pt-2">
            {NAV.map((n) => (
              <li key={n.id}>
                <a href={`#${n.id}`} onClick={go(n.id)} className="flex items-center justify-between py-3.5 font-display text-xl" data-testid={`mobile-nav-link-${n.id}`}>
                  {n.label} <ArrowRight size={18} className="text-[#0F6E56]" />
                </a>
              </li>
            ))}
            <li><Link to="/guide" className="flex items-center justify-between py-3.5 font-display text-xl" data-testid="mobile-nav-link-guide">Guide <ArrowRight size={18} className="text-[#0F6E56]" /></Link></li>
          </ul>
          <a href="#richiedi" onClick={go("richiedi")} className="rl-btn rl-btn-amber mt-4 w-full" data-testid="mobile-nav-cta">
            Richiedi una figura
          </a>
        </nav>
      )}
    </header>
  );
};
